<template>
  <base-modal :modal-id="modalId" centered size="lg">
    <template v-slot:header>
      <h4 class="modal-title mb-0 d-sm-none">{{ _T('Forgot Password') }}</h4>
      <h4 class="modal-title mb-0 d-none d-sm-block">
        {{ _T('Forgot your password?') }}
      </h4>
    </template>
    <template v-slot:modal-body>
      <div class="authentication">
        <div class="col-lg-12 p-0">
          <div class="auth-right">
            <div>
              <div
                class="d-flex d-lg-none mb-2"
                style="justify-content:space-between;"
              >
                <h2>
                  {{ _T('Reset password') }}
                </h2>
                <a href="#" class="d-lg-none" @click="$bvModal.hide(modalId)"
                  ><svg width="14" height="14" fill="none">
                    <use xlink:href="#closeIcon"></use></svg
                ></a>
              </div>
              <div class="auth-bottom d-block pt-0">
                <h6>{{ _T('Login if you have password') }}</h6>

                <button
                  class="btn btn-outline ml-2"
                  @click="proceedFurther('login')"
                >
                  {{ _T('Login') }}
                </button>
              </div>
              <div class="login-form">
                <form class="default-form">
                  <div class="form-group" v-if="loginWithPhoneNumber">
                    <label>{{ _T('Phone Number') }}</label>
                    <phone-number-input
                      @custom-input="payload => (phone_number = payload)"
                    />
                  </div>
                  <div class="form-group" v-else>
                    <label>{{ _T('Email') }}</label>
                    <input
                      required
                      v-model="login"
                      type="text"
                      class="form-control"
                      value=""
                      :placeholder="_T('Email address')"
                    />
                  </div>
                  <div class="single-row">
                    <button
                      type="button"
                      class="btn btn-outline btn-block"
                      @click.prevent="
                        loginWithPhoneNumber = !loginWithPhoneNumber
                      "
                    >
                      {{
                        loginWithPhoneNumber
                          ? _T('Reset using Email')
                          : _T('Reset using Phone')
                      }}
                    </button>
                    <progress-bar
                      v-if="processInProgress(process)"
                      :btn-large="true"
                    >
                      {{ _T('Resetting') }}
                    </progress-bar>
                    <button
                      v-else
                      class="btn btn-solid btn-block mt-0"
                      @click.prevent="recover()"
                    >
                      <span>{{ _T('Reset') }}</span>
                    </button>
                  </div>
                  <div
                    v-if="login_fail_message || login_success_message"
                    class="alert fade show mt-3"
                    :class="
                      login_fail_message
                        ? 'alert-danger'
                        : login_success_message
                        ? 'alert-success'
                        : ''
                    "
                    role="alert"
                  >
                    {{
                      login_fail_message
                        ? login_fail_message
                        : login_success_message
                        ? login_success_message
                        : ''
                    }}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import { validateEmail, validatePhoneNumber } from '@/utils/main_utils'
import BaseModal from '@/components/Modals/BaseModal'
import ProgressBar from '@/components/Elements/ProgressBar'
import PhoneNumberInput from '@/components/Elements/PhoneNumberInput.vue'

export default {
  name: 'ForgotPassword',
  data() {
    return {
      login: '',
      phone_number: '',
      modalId: 'forgot-password',
      process: 'forgot-password',
      loginWithPhoneNumber: false,
    }
  },
  watch: {
    phone_number() {
      this.$nextTick(() => {
        this.determineLoginType()
      })
    },
    login() {
      this.$nextTick(() => {
        this.determineLoginType()
      })
    },
  },
  components: {
    BaseModal,
    ProgressBar,
    PhoneNumberInput,
  },
  computed: {
    ...mapGetters([
      'login_success_message',
      'login_fail_message',
      'login_in_progress',
      '_T',
      'domainBasedBrand',
      'processInProgress',
    ]),
  },
  methods: {
    proceedFurther(modalToShow) {
      this.$bvModal.hide('forgot-password')
      this.$bvModal.show(modalToShow)
    },
    determineLoginType() {
      this.$store.dispatch('set_login_failure_message', '')
      if (!this.loginWithPhoneNumber) {
        if (!validateEmail(this.login)) {
          this.$store.dispatch(
            'set_login_failure_message',
            'Incorrectly formatted email'
          )
          return false
        }
      } else {
        if (!validatePhoneNumber(this.phone_number)) {
          this.$store.dispatch(
            'set_login_failure_message',
            'Incorrectly formatted phone number'
          )
          return false
        }
      }
      return true
    },
    recover() {
      if (!this.processInProgress(this.process) && this.determineLoginType()) {
        let mobile = ''
        let email = ''

        if (this.loginWithPhoneNumber) {
          mobile = this.phone_number
            .toString()
            .replace(/\+/g, '')
            .replace(/\s/g, '')
        } else {
          email = this.login.toString().toLowerCase()
        }
        this.$store.dispatch('startProcess', {
          process: this.process,
          progress: true,
        })
        this.$store
          .dispatch('send_password_recovery_letter', {
            email,
            mobile,
            mode: this.loginWithPhoneNumber ? 'phone_number' : 'email',
            brand_id: this.domainBasedBrand || '',
          })
          .then(() => {})
          .finally(() => {
            this.$store.dispatch('stopProcess', this.process)
          })
      }
    },
  },
}
</script>

<style lang="scss">
.authentication {
  background-color: $white !important;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    width: 0 !important;
  }
  .signup-form {
    height: 100vh;
    overflow: auto;
  }
  .auth-left {
    background-image: url('/images/login-bg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100vh;
    position: absolute;
    img {
      position: absolute;
      left: 8.33%;
      top: 5.67%;
    }
  }
  .login-logo {
    text-align: center;
    display: none;
  }
  .auth-right {
    display: flex;
    align-items: center;
    justify-content: center;
    // height: 100vh;
    width: 100%;
    position: relative;
    a {
      font-weight: 500;
    }
    .login-form {
      width: $px420;
      .default-form {
        .single-row {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-column-gap: $px10;
          @media (max-width: 575px) {
            grid-template-columns: 1fr;
            grid-row-gap: $px10;
          }
        }
      }
      .header-mobile {
        display: none;
      }
      h2 {
        color: $font-color;
        text-transform: capitalize;
        margin-bottom: $px20;
      }
      h6 {
        line-height: $px22;
        letter-spacing: 0.5px;
        color: $font-color;
        margin-bottom: calc(
          #{$px20} + (33 - 20) * ((100vw - #{$px320}) / (1920 - 320))
        );
      }
      .remember {
        padding-bottom: $px5;
        label {
          color: $light-font;
          font-weight: 500;
          margin-bottom: 0;
        }
        a {
          float: right;
        }
      }
      .divider {
        padding-top: $px24;
        position: relative;
        clear: both;
        height: 0;
        margin: $px33 0 $px9;
        border-top: $px1 solid $light-border;
        &::before {
          position: absolute;
          top: -$px11;
          left: 47%;
          font-size: $px13;
          line-height: $px22;
          letter-spacing: 0.5px;
          margin-left: -$px10;
          padding: 0 $px10;
          content: 'OR';
          color: $light-font;
          background: $white;
        }
      }
      .btn {
        padding: $px15 0;
        position: relative;
        text-transform: capitalize;
        i,
        img {
          position: absolute;
          font-size: $px22;
          top: 26%;
          left: 5%;
        }
        &.btn-google {
          margin-top: 0;
          margin-left: $px15;
          background: $light-border;
        }
      }
    }
    .auth-bottom {
      text-align: right;
      padding-bottom: $px10;
      // padding: calc(#{$px25} + (50 - 25) * ((100vw - #{$px320}) / (1920 - 320)))
      //   0 calc(#{$px20} + (50 - 20) * ((100vw - #{$px320}) / (1920 - 320)));
      h6 {
        font-weight: 300;
        letter-spacing: 0.5px;
        color: $font-color;
        display: inline-block;
        margin-right: $px10;
      }
    }
  }
  .button-group {
    align-items: center;
  }
}
@media (max-width: 1199px) {
  .authentication {
    .auth-right {
      .login-form {
        .divider {
          margin: $px15 0 -$px8;
        }
      }
    }
  }
}
@media (max-width: 991px) {
  .authentication {
    position: fixed;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    left: 0;
    top: 0;
    overflow: auto;
    .signup-form {
      height: auto;
    }
    > .row {
      width: 90vw;
    }
    .auth-left {
      display: none;
    }
    .login-logo {
      margin: calc(#{$px20} + (40 - 20) * ((100vw - #{$px320}) / (1920 - 320)))
        0 calc(#{$px30} + (92 - 30) * ((100vw - #{$px320}) / (1920 - 320)));
      display: block;
    }
    .auth-right {
      align-items: unset;
      height: auto;
      padding: 0 $px20;
      > div {
        width: 100%;
      }
      .login-form {
        width: 100%;
        .remember {
          margin-bottom: $px55;
        }
        h2 {
          margin-bottom: $px14;
        }
        .divider {
          margin: 16px 0 -$px6;
        }
      }
      .auth-bottom {
        position: relative;
        right: unset;
        text-align: left;
        top: unset;
        // margin-top: $px45;
        h6 {
          font-weight: 600;
          font-size: $px12 !important;
          line-height: $px17;
          text-align: center;
          letter-spacing: 0.02em;
          margin: 0;
          margin-right: $px5 !important;
        }
        .btn {
          margin-left: $px10;
        }
      }
      .login-form {
        .btn {
          i,
          img {
            left: 10%;
          }
        }
      }
    }
  }
}
@media (width: 640px) and (height: 360px) {
  .authentication {
    align-items: flex-start;
  }
}
@media (max-width: 575px) {
  .authentication {
    padding: 1.5rem !important;
    > .row {
      width: 100vw;
    }
    .p-0 {
      padding: 0 $px15 !important;
    }
    .auth-right {
      padding: 0;
      .login-form {
        width: auto;
      }
    }
    &.sign-up {
      align-items: flex-start;
    }
  }
}
@media (max-width: 360px) {
  .authentication {
    align-items: flex-start;
    .auth-right {
      .login-form {
        .btn {
          padding: $px15 0 $px15 0;
        }
      }
      .auth-bottom {
        .btn {
          margin-top: $px10;
          margin-left: 0;
        }
      }
    }
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .authentication {
    .signup-form {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.body-rtl {
  .authentication {
     .auth-right  {
       .auth-bottom {
         left: unset;
         text-align: right;
       }
     }
  }
}
</style>
